<div class="clockdiv" *ngIf="!disabled" #element>
  <div>
    <span class="days"></span>
    <div class="smalltext">Dni</div>
  </div>
  <div>
    <span class="hours"></span>
    <div class="smalltext">Godziny</div>
  </div>
  <div>
    <span class="minutes"></span>
    <div class="smalltext">Minuty</div>
  </div>
  <div>
    <span class="seconds"></span>
    <div class="smalltext">Sekundy</div>
  </div>
</div>